import { useDispatch, useSelector } from 'react-redux';

import { SubscriberResponseDto } from 'theSource/types';
import { useApiQuery } from 'theSource/utils';
import {
  selectIsAuthenticated,
  selectIsAdmin,
  setAuthenticated,
} from 'theSource/features';
import { GET_SUBSCRIBER_QUERY_KEY } from './utils';
import { INVALID_SUBSCRIBER_ERROR_CODE } from 'queries';

export interface UseSubscriberQueryOutput {
  subscriber?: SubscriberResponseDto;
  isLoadingSubscriber: Boolean;
  isFetchingSubscriber: Boolean;
}

interface SubscriberQueryProps {
  restrictAdmin?: boolean;
}

export const useSubscriberQuery = ({
  restrictAdmin = false,
}: SubscriberQueryProps = {}): UseSubscriberQueryOutput => {
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isAdmin = useSelector(selectIsAdmin);
  const enabledForAdmin = restrictAdmin ? !isAdmin : true;
  const {
    data: subscriber,
    isLoading: isLoadingSubscriber,
    isFetching: isFetchingSubscriber,
  } = useApiQuery<SubscriberResponseDto>({
    queryKey: GET_SUBSCRIBER_QUERY_KEY,
    endpoint: '/subscriber',
    enabled: Boolean(isAuthenticated && enabledForAdmin),
    onError(err) {
      if (err.response?.data?.error_code === INVALID_SUBSCRIBER_ERROR_CODE) {
        dispatch(setAuthenticated(false));
      }
    },
  });

  return { subscriber, isLoadingSubscriber, isFetchingSubscriber };
};
